/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Register_Account_TitleInputs */

const de_login_register_account_title = /** @type {(inputs: Login_Register_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugangsdaten festlegen`)
};

/** @type {(inputs: Login_Register_Account_TitleInputs) => LocalizedString} */
const en_login_register_account_title = de_login_register_account_title;

/**

* @param {Login_Register_Account_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_register_account_title = /** @type {((inputs?: Login_Register_Account_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Register_Account_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_register_account_title(inputs)
	return en_login_register_account_title(inputs)
});